import { Layout } from '@eneco/flows/components';
import { createFlowProvider } from '@eneco/flows/utils';

import { routes, actions, initialContext } from './SolarBoilerLeadFlow.config';
import { SolarBoilerLeadFlowContext } from './types/context';

const { Provider, Navigation, Router } = createFlowProvider<SolarBoilerLeadFlowContext>({
  routes,
  actions,
  initialContext,
});

const Flow = () => {
  return (
    <Provider>
      <Layout>
        <Layout.Header>
          <Navigation componentName="SolarBoilerLeadFlowNavigation" />
        </Layout.Header>

        <Router />
      </Layout>
    </Provider>
  );
};

export default Flow;
